import { render, staticRenderFns } from "./NoClinics_OpenDental.vue?vue&type=template&id=711f16b5&scoped=true&"
import script from "./NoClinics_OpenDental.vue?vue&type=script&lang=js&"
export * from "./NoClinics_OpenDental.vue?vue&type=script&lang=js&"
import style0 from "./NoClinics_OpenDental.vue?vue&type=style&index=0&id=711f16b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711f16b5",
  null
  
)

export default component.exports